import "@fontsource-variable/inter";
import { MantineProvider } from "@mantine/core";
import { PropsWithChildren } from "react";

import { cssVariablesResolver } from "#app/theme/v2/cssVariablesResolver";

import { theme } from ".";

export const ThemeProviderV2 = ({ children }: PropsWithChildren) => (
  <MantineProvider theme={theme} cssVariablesResolver={cssVariablesResolver}>
    {children}
  </MantineProvider>
);
